import { useEffect } from "react";
import { CheckCircle2 } from "lucide-react";
import Seo from "@/components/Seo";
import BookingCalendar from "@/components/BookingCalendar";
import { trackLead } from "@/lib/pixel";

/**
 * Standalone in-target thank-you page.
 *
 * Reached via direct link from external funnels that DO NOT pass through the
 * `/lp/prenota-call` form. Fires the Meta Pixel `Lead` event on mount and
 * shows the GHL booking calendar (no prefill, since we have no form data).
 *
 * The existing `/lp/prenota-call` post-submit flow is untouched.
 */
export default function ThankYouInTarget() {
  useEffect(() => {
    trackLead({
      content_name: "Thank you page (in-target)",
      content_category: "ty-in-target",
    });
  }, []);

  return (
    <>
      <Seo
        title="Grazie, Lovac"
        description="Richiesta ricevuta. Prenota lo slot che preferisci."
        path="/lp/grazie/in-target"
        noindex
      />

      <div className="bg-lovac border-b border-lovac">
        <div className="container-lovac px-6 py-5 flex items-center">
          <img src="/images/logo-orizzontale.png" alt="Lovac" className="h-7 sm:h-8" />
        </div>
      </div>

      <section
        className="py-20 lg:py-24 bg-lovac-dark text-on-dark grain relative overflow-hidden"
        data-testid="ty-in-target-section"
      >
        <div className="container-narrow relative z-10">
          <div className="text-center">
            <CheckCircle2 size={56} className="text-lovac-accent mx-auto" />
            <h1
              className="font-display text-3xl sm:text-4xl lg:text-5xl mt-6 text-on-dark leading-tight"
              data-testid="ty-in-target-title"
            >
              Un ultimo step per completare la tua richiesta.
            </h1>
            <p className="text-on-dark-muted mt-5 max-w-xl mx-auto leading-relaxed">
              La richiesta è già arrivata al nostro team. Scegli qui sotto lo slot che preferisci
              per parlare con un consulente Lovac.
            </p>
          </div>

          <div
            className="mt-10 rounded-2xl bg-white overflow-hidden shadow-2xl"
            data-testid="ty-in-target-booking-wrapper"
          >
            <BookingCalendar id="booking-ty-in-target" />
          </div>
        </div>
      </section>
    </>
  );
}
